/**
 * @ngdoc component
 * @name mx.shell:mxShellNavTabsLevel
 * @module mx.shell
 * @description Shows Navigation Level as Tabs (used for 3rd level)
 * @param {object} parentNavItem= - parent Navigation Item
 */

import template from './mx-shell-nav-tabs-level.html';

export const mxShellNavTabsLevelComponent = {
	bindings: {},
	controller: MxShellNavTabsLevelCtrl,
	controllerAs: 'vm',
	template,
};

MxShellNavTabsLevelCtrl.$inject = ['$scope', 'mx.shell.EventService', 'mx.shell.NavigationService'];

function MxShellNavTabsLevelCtrl($scope, eventService, navigationService) {
	const vm = this;

	vm.tabNavItems = [];
	let _originalClickingEvent;

	vm.handleGeneralTabsClick = ($event) => {
		_originalClickingEvent = $event;
	};

	vm.handleItemClick = ($event, item) => {
		if (_originalClickingEvent) {
			eventService.dispatchEvent(mx.shell.EventCodes.TrackTelemetry, { eventName: `Navigation clicked`, sender: item.id, senderTitle: item.technicalName });
		}

		let itemToBeOpen = item;
		while (!itemToBeOpen.route && itemToBeOpen.children?.length) {
			itemToBeOpen = itemToBeOpen.children[0];
		}

		navigationService
			.setCurrentNavigationItem(itemToBeOpen)
			.then(() => {
				eventService.dispatchEvent(mx.shell.EventCodes.NavigationItemClicked, { navigationItem: itemToBeOpen, $event: _originalClickingEvent });
				_originalClickingEvent = undefined;
			})
			.catch(mx.logCatch);
	};

	eventService.subscribeTo(mx.shell.EventCodes.CurrentNavigationItemChanged, (e, { navigationItem }) => handleNavSwitching(navigationItem), $scope);

	eventService.subscribeTo(mx.shell.EventCodes.NavigationItemClicked, (e, { navigationItem }) => handleNavSwitching(navigationItem), $scope);

	const handleNavSwitching = $.debounce(100, (navigationItem) => {
		if (!navigationItem) {
			return;
		}
		$scope.$applyAsync(function () {
			const tabsLevelItem = navigationService.getTabsLevelItem(navigationItem);
			if (tabsLevelItem?.children?.length > 0) {
				vm.parentNavItem = tabsLevelItem;
				vm.tabNavItems = vm.parentNavItem.children;
			} else {
				vm.parentNavItem = null;
				vm.tabNavItems = [];
			}
		});
	});
}
